<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

     <!-- <el-tabs class="mt-0" v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="Profile" name="Profile"> -->
          <br>

          <div class="row">
            <fg-input type="text" class="col-5"
                label="Name"
                placeholder="Name"
                v-model="name"
                :disabled="archived"/>
                
            <fg-input v-if="archived" class="col"
                type="text"
                label="User Profile"
                placeholder="User Profile"
                :value="$store.getters.userProfiles.find(prof => prof.id == profileId).name"
                disabled/>

            <fg-input v-else label="User Profile" class="col">
              <el-select class="select-transparent removeReadonly" v-model="profileId" :filterable="false">
                <el-option v-for="profile in $store.getters.userProfiles"
                      :value="profile.id"
                      :label="profile.name"
                      :key="profile.id"/>
              </el-select>
            </fg-input>
          </div>

          <div class="row">
            <fg-input type="text" class="col-7"
                label="Email / Username"
                placeholder="Email"
                v-model="email"
                :disabled="archived"/>

            <fg-input type="password" class="col"
                label="Password"
                placeholder="Password"
                v-model="password"
                :disabled="archived"/>
          </div>

          <fg-input type="text"
              label="Position"
              placeholder="Position"
              v-model="position"
              :disabled="archived"/>

          <fg-input type="text"
              label="Phone"
              placeholder="Phone"
              v-model="phone"
              :disabled="archived"/>

          <fg-input label="Notes">
            <el-input type="textarea"
                      :autosize="{minRows: 2}"
                      placeholder="Notes"
                      v-model="notes"
                      :disabled="archived"/>
          </fg-input>

        <!-- </el-tab-pane>
        <el-tab-pane label="Payouts" name="Payouts">
          <Payouts-Table :forAffiliate="affiliate" hideAddPayout/>
        </el-tab-pane>
      </el-tabs> -->

    

    <span slot="footer" class="dialog-footer">
      <div class="row">
        <span v-if="modalState.mode != 'Create'" class="col-1">
          <button v-if="deletable" class="btn btn-danger" @click="deleteUser()">Delete</button>
          <button v-else-if="archived" class="btn" @click="toggleArchive()">Unarchive</button>
          <button v-else class="btn" @click="toggleArchive()">Archive</button>
          <!-- <button v-else class="btn" @click="test">Archive</button> -->
        </span>

        <span class="ml-auto col-4">
          <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
          <button class="btn btn-success" @click="save()">{{buttonLabel}}</button>
        </span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import {Affiliate, AffiliateCompanyProxy} from 'src/classes/datamodel.js'
export default {
  name: 'User-Modal',
  data () {
    return {
      activeTab: 'Profile'
    }
  },
  computed: {
    modalState () {
      return this.$store.getters.modal
    },
    usersSetup () {
      return this.$store.getters.usersSetup
    },
    title () {
      return this.modalState.mode + ' User'
    },
    visible () {
      return this.$store.state.modal.current == 'User'
    },
    buttonLabel () {
      return this.modalState.mode == 'Create' ? 'Create' : 'Save'
    },
    user () {
      return this.modalState.object && this.visible || {}
    },
    archived: { get()  { return this.user.archived; },
                set(archived) { this.user.archived = archived }
    },
    name: { get() { return this.user.name; },
            set(name)    { this.user.name = name }
    },
    profileId: { get() { return this.user.profileId },
               set(profileId) { this.user.profileId = profileId }
    },
    email: { get() { return this.user.email },
             set(email)   { this.user.email = email }
    },
    password: { get()  { return this.user.password },
                set(password) { this.user.password = password}
    },
    position: { get()  { return this.user.position },
                set(position) { this.user.position = position }
    },
    phone: { get() { return this.user.phone },
             set(phone)   { this.user.phone = phone }
    },
    notes: { get() { return this.user.notes },
             set(notes)   { this.user.notes = notes }
    },
    deletable: { get() { return this.user.deletable },
                 set(deletable) { this.user.deletable = deletable }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
      // we hide any edit input field (for manual payouts) that would still be open
      // (otherwise they'll appear in the next Payout table...)
      $('.toHideWhenClosing').each(function() {
        $(this).addClass('d-none')
      })
      // and show the normmal divs back
      $('.toShowWhenClosing').each(function() {
        $(this).removeClass('d-none')
      })/* 
      setTimeout(() => { // We wait till the modal disapears completely and then reset the tab
        this.activeTab = 'Profile'
      }, 500);  */
    },
    toggleArchive () {
      this.archived = !this.archived
    },
    async save () {
      var mode = this.$store.state.modal.mode
      const res = await this.$store.dispatch(mode=='Edit'?'updateRestObject':'createRestObject', this.user)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Saved!'})
             this.closeModal()
      }
    },
    handleClick(tab, event) {
      //console.log(tab, event)
    },
    async deleteUser () {
      const res = await this.$store.dispatch('deleteRestObject', this.user)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Deleted!'})
             this.closeModal()
      }
    }
  }/* ,
  watch: {
    visible: function (elem) {
      console.log('Watch modalState')
      this.modalState.object = this.$store.state.modals['Affiliate'].object
    }
  } */
}
</script>

<style>

</style>